const blue = {
  main: '#0066cc',
  97: '#f2f7fc',
  87: '#bfdfff',
  77: '#94c4f5',
  67: '#6aaaeb',
  57: '#4392e0',
  48: '#207bd6',
  45: '#0077ce',
  40: '#0066cc',
  35: '#0056AC',
  30: '#004d99',
  20: '#004080',
  15: '#003366',
};
const green = {
  main: '#008055',
  87: '#c8f6e7',
  77: '#99eed2',
  67: '#6ee7bf',
  57: '#43e0ac',
  48: '#22d499',
  40: '#00cc88',
  30: '#00b377',
  25: '#008055',
  20: '#006644',
  15: '#004d33',
};
const red = {
  main: '#cc334d',
  96: '#fbeff1',
  90: '#f5d6db',
  80: '#ebadb8',
  70: '#e08593',
  60: '#d65c70',
  50: '#cc334d',
  44: '#b32d43',
  37: '#992639',
  30: '#7a1f2e',
  25: '#661a26',
};
const orange = {
  main: '#cc7a00',
  87: '#f6e4c8',
  77: '#eecd9a',
  67: '#e7b66e',
  57: '#e0a243',
  48: '#d48d22',
  40: '#cc7a00',
  35: '#b36b00',
  30: '#995c00',
  25: '#804d00',
  20: '#663d00',
};

const grey = {
  main: '#a3a6b2',
  100: '#ffffff',
  97: '#f7f7fa',
  91: '#e8e8e8',
  87: '#DFDFDF',
  80: '#cccccc',
  60: '#989898',
  58: '#959595',
  50: '#82848e',
  39: '#646464',
  36: '#5c5c5c',
  27: '#454545',
  25: '#3E3E3E',
  21: '#3c3c3c',
  20: '#323232',
  14: '#232323',
  13: '#222222',
  0: '#000000',
};

export const CircleImageColors = [
  '#004080',
  '#006644',
  '#b32d43',
  '#995c00',
  '#0077ce',
  '#992639',
  '#008055',
];

const colors = (theme) => {
  const themeColors = {};
  const mainColor = blue.main;
  switch (theme) {
    case 'darkTheme':
      themeColors.bgPrimary = '#222222';
      themeColors.bgSecondary = '#1b1b21';
      themeColors.textPrimary = '#eeeeee';
      themeColors.textSecondary = '#cccccc';
      themeColors.bgCalendar = '#222222';
      themeColors.link = '#2589FF';
      themeColors.linkHover = '#66bbff';
      themeColors.btnHover = '#0066cc';
      themeColors.btnBgHover = '#000000';
      themeColors.border = '#404040';
      themeColors.loader = '#C0C0C0';
      themeColors.themeColor = mainColor;
      break;

    case 'mainTheme':
    default:
      themeColors.bgPrimary = grey['100'];
      themeColors.bgSecondary = '#F9FCFF';
      themeColors.textPrimary = '#131313';
      themeColors.textSecondary = grey['39'];
      themeColors.bgCalendar = grey['97'];
      themeColors.btnBgHover = grey['91'];
      themeColors.border = grey['80'];
      themeColors.link = blue['35'];
      themeColors.linkHover = '#333333';
      themeColors.btnHover = blue['20'];
      themeColors.loader = blue['15'];
      themeColors.themeColor = mainColor;
      break;
  }

  return {
    // Main colors
    ...themeColors,
    title: blue['35'],
    aside: '#E9F3FF',
    darkerBlue: '#22408B',
    bgHeader: blue['30'],
    bgSubHeader: blue['40'],
    bgFooter: blue['15'],
    bgSubFooter: '#22408B',
    focusSelect: blue['15'],
    calendar: blue['45'],
    iconBg: blue['97'],
    /* scrollbar */
    scrollbarTrack: '#EDEDED',
    scrollbarThumb: '#595959',
    /* btn */
    btnMain: blue['35'],
    btnHover: '#333333',
    btnDisabledText: grey['39'],
    btnDisabledBg: '#E3E3E3',
    focusRing: grey['0'],
    /* badge */
    badgePrimary: blue['35'],
    badgeNews: '#22408B',
    badgeActive: blue['15'],
    badgeDot: '#FF6F5F',
    badgeDashedText: '#333333',
    badgeDashedBorder: grey['39'],
    selectedNotification: blue['77'],
    badgeLightBlueBg: '#EFF5FB',
    /* Course status */
    completedColor: '#0088e3',
    incompleteColor: '#43C4FF',
    emptyColor: '#C67EFF',
    mandatory: '#7E3AB5',
    /* Box */
    bgBox: '#EFF5FB',
    separator: grey['39'],
    /* Grey */
    primaryDarkGray900: '#131313',
    primaryDarkGray700: '#515151',
    primaryDarkGray600: '#646464',
    primaryDarkGray500: '#8B8B8B',
    primaryDarkGray400: '#ACACAC',
    greyMedium: grey.main,
    trueBlack: grey['0'],
    black: grey['13'],
    mineShaft2: grey['14'],
    doveGray: grey['20'],
    darkerGrey: grey['21'],
    mineShaft: grey['25'],
    date: grey['27'],
    gray: grey['36'],
    placeholder: grey['39'],
    blueGrey: grey['50'],
    greyLighter: grey['58'],
    brownGrey: grey['60'],
    silverGrey: grey['80'],
    greyLight: grey['91'],
    lightCard: grey['97'],
    white: grey['100'],
    transparent: 'transparent',

    black20: 'rgba(0, 0, 0, 0.2)',
    black30: 'rgba(0, 0, 0, 0.3)',
    black40: 'rgba(0, 0, 0, 0.4)',
    black50: 'rgba(0, 0, 0, 0.5)',
    black70: 'rgba(63, 63, 63, 0.7)',
    sharkLight: '#1F2025',
    midGray: '#575a64',

    /* Secondary */
    orangeDarker: orange.main,
    gold: orange['57'],
    quizBtn: orange['87'],
    fail: red['50'],
    redError: red['44'],
    darkRed: red['30'],
    azureDark: blue['48'],
    success: green['25'],
    successIcon: green['25'],
    expired: red['37'],
    successMessage: '#03603F',
    notificationNotRead: '#eff5fb',

    /* Form */
    disabled: '#D9DADB',

    /* Radio-btn */
    radioBtnDefault: '#0056AC',
    radioBtnHover: '#333333',
    radioBtnChecked: '#003366',
    radioBtnDisabled: '#646464',
    radioBtnQuiz: '#1A1A1A',
  };
};

export default colors;
